import { render, staticRenderFns } from "./banner-slider.vue?vue&type=template&id=5db6ce76&scoped=true&"
import script from "./banner-slider.vue?vue&type=script&lang=js&"
export * from "./banner-slider.vue?vue&type=script&lang=js&"
import style0 from "./banner-slider.vue?vue&type=style&index=0&id=5db6ce76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db6ce76",
  null
  
)

export default component.exports